export type OperatingSystem = 'mac' | 'windows' | 'linux';

export const detectBrowserOperatingSystem = (): OperatingSystem => {
  if (typeof navigator === 'undefined') {
    return 'mac';
  }

  const navigatorWithUserAgentData = navigator as Navigator & {
    userAgentData?: {
      platform?: string;
    };
  };
  const platform = navigatorWithUserAgentData.userAgentData?.platform || navigator.platform || navigator.userAgent;
  const normalizedPlatform = platform.toLowerCase();

  if (normalizedPlatform.includes('win')) {
    return 'windows';
  }

  if (normalizedPlatform.includes('linux')) {
    return 'linux';
  }

  return 'mac';
};
